import type {
  ImportAlphaSpreadsheetRequest,
  ImportAlphaSpreadsheetResponse,
} from '@snap-types/actions/import-alpha-spreadsheet';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSiteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [importAlphaSpreadsheet, useImportAlphaSpreadsheetMutation] =
  injectMutation<ImportAlphaSpreadsheetRequest, ImportAlphaSpreadsheetResponse>(
    `${QUOTE_BUILDER_SLICE_NAME}/importAlphaSpreadsheet`,
    ({ params, body }) => ({
      url: buildSiteUrl(
        params.siteCode,
        `auto-configurator/alpha/${params.alphaQuoteUuid}/snap-quotes/${params.snapQuoteUuid}/import-lines`,
      ),
      method: 'POST',
      body,
    }),
  );
